import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSadEmotion = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <circle cx={10} cy={10} r={10} fill="#FFB03D" />
    <path
      fill="#00265D"
      stroke="#00265D"
      strokeWidth={0.043}
      d="M14.096 7.94c0 .64-.482 1.155-1.073 1.155-.592 0-1.074-.516-1.074-1.155 0-.64.482-1.155 1.074-1.155.591 0 1.073.516 1.073 1.155Zm-5.75 0c0 .64-.482 1.155-1.074 1.155S6.198 8.58 6.198 7.94c0-.64.482-1.155 1.074-1.155s1.074.516 1.074 1.155Z"
    />
    <path
      stroke="#00265D"
      strokeLinecap="round"
      strokeWidth={1.176}
      d="M14.706 14.41S13.088 12.94 10 12.94s-4.706 1.47-4.706 1.47"
    />
  </svg>
);
export default SvgSadEmotion;
